export function setTempoAtual(state) {
  state.jornada.fim = Date.now()
  if (state.historico.length) {
    state.historico[state.historico.length - 1].fim = state.jornada.fim
  }
}
